import axios from "./axios"

function getPathWithQuery(path, query) {
  if (query) {
    var queryString = Object.keys(query)
      .map(key => key + "=" + query[key])
      .join("&")
    if (queryString != "") {
      return path + "?" + queryString
    }
  }
  return path
}

function get(path, query) {
  return axios
    .get(getPathWithQuery(path, query))
    .then(function(response) {
      return Promise.resolve(response.data)
    })
    .catch(function(error) {
      return Promise.reject(error.response.data.error)
    })
}

function post(path, data) {
  return axios
    .post(path, data)
    .then(function(response) {
      return Promise.resolve(response.data)
    })
    .catch(function(error) {
      return Promise.reject(error.response.data.error)
    })
}

function patch(path, data) {
  return axios
    .patch(path, data)
    .then(function(response) {
      return Promise.resolve(response.data)
    })
    .catch(function(error) {
      return Promise.reject(error.response.data.error)
    })
}

function put(path, data) {
  return axios
    .post(path, data)
    .then(function(response) {
      return Promise.resolve(response.data)
    })
    .catch(function(error) {
      return Promise.reject(error.response.data.error)
    })
}

function _delete(path, data) {
  var _data = { data: data }
  return axios
    .delete(path, _data)
    .then(function(response) {
      return Promise.resolve(response.data)
    })
    .catch(function(error) {
      return Promise.reject(error.response.data.error)
    })
}

function postFormData(path, formData) {
  return axios
    .post(path, formData, {
      headers: { "Content-Type": "multipart/form-data" }
    })
    .then(function(response) {
      return Promise.resolve(response.data)
    })
    .catch(function(error) {
      return Promise.reject(error.response.data.error)
    })
}

export { get, post, put, patch, _delete as delete, postFormData, getPathWithQuery }
